// const refreshTime = 1 * 60 * 1000; // 20分 (20分 = 20 * 60 * 1000 ミリ秒)
const refreshTime = 1 * 60 * 1000; // 20分 (20分 = 20 * 60 * 1000 ミリ秒)

const CLIENT_ID =
  "366805150657-gg5brchdnsgdq5osbuo0v5fr21b1stc8.apps.googleusercontent.com";
const API_KEY = "AIzaSyCehjtaYfZ3T9bRUP3jkWo9n94zWlwnTAs";
const SCOPES = [
  "https://www.googleapis.com/auth/gmail.send",
  // Add other scopes as needed
];

export { refreshTime, CLIENT_ID, API_KEY, SCOPES };
